import React from "react";
import { FaTools } from "react-icons/fa";

const Portal = () => {
  return (
    <div className="page-container portal-page">
      <section className="home-card construction-card">
        <div className="construction-content">
          <FaTools className="construction-icon" />
          <h2 className="construction-title">Portal - Under Construction</h2>
          <p className="construction-message">
            This page is currently under development and will be available soon.
          </p>
          <div className="construction-details">
            <p>Please check back later or contact us for more information.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portal;